import { useEffect } from 'react'
import { leaveGuard } from '@/lib/leaveGuard'

/**
 * Hold the tab while `active`, and let go on unmount.
 *
 * The key is the owner's name rather than the reason, so a component whose
 * reason changes wording does not leave a stale claim behind — and so two
 * instances of the same thing cannot each hold the tab independently.
 */
export function useLeaveGuard(key: string, active: boolean, reason: string): void {
  useEffect(() => {
    if (!active) {
      leaveGuard.release(key)
      return
    }
    leaveGuard.claim(key, reason)
    return () => leaveGuard.release(key)
  }, [key, active, reason])
}
